import _ from 'lodash';

const SlaArticleText = ({lessor, description, attributes}) => {
  return (
    <>
      SLA
      {description && lessor ? (
        <>&nbsp;&middot;&nbsp;{attributes?.option_id ? lessor : description}</>
      ) : null}
    </>
  );
};

export default SlaArticleText;
